/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Client API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface IdeaUpdate
 */
export interface IdeaUpdate {
    /**
     * 
     * @type {string}
     * @memberof IdeaUpdate
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof IdeaUpdate
     */
    description?: string;
}

export function IdeaUpdateFromJSON(json: any): IdeaUpdate {
    return {
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function IdeaUpdateToJSON(value?: IdeaUpdate): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'title': value.title,
        'description': value.description,
    };
}


